import { SelectC } from 'components'
import { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import { useOrderStore } from 'modules/orders/store'
import { FieldWrapper } from 'components/Form/FieldWrapper'
import { useLoadOrderSaleTypeByUser } from 'modules/orders/hooks/useLoadOrderSaleTypeByUser'

export const SelectOrderType = () => {
  const { setValue, watch } = useFormContext()

  const orderType = watch('orderType')
  const form = useOrderStore.useForm()

  const { data, isLoading } = useLoadOrderSaleTypeByUser()

  useEffect(() => {
    if (!orderType) setValue('orderType', data?.defaultValue || null)
  }, [data, setValue, orderType])

  return (
    <>
      <SelectC
        name="orderType"
        label="Tipos de Venda"
        loading={isLoading}
        options={data?.data}
        disabled={form?.orderItems?.length}
        getOptionLabel={(option: any) => option?.name}
        onChange={() => setValue('deliveryAddressCompany', null)}
      />

      {form?.orderItems?.length > 0 && (
        <FieldWrapper
          error={{
            message: 'Para mudar o tipo de venda, remova os itens do pedido!'
          }}
        >
          <div />
        </FieldWrapper>
      )}
    </>
  )
}
